import { render, staticRenderFns } from "./e-input-birthday.vue?vue&type=template&id=45f41e5d&scoped=true&"
import script from "./e-input-birthday.vue?vue&type=script&lang=js&"
export * from "./e-input-birthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f41e5d",
  null
  
)

export default component.exports